//Componentes generales
import React, { useEffect, useState } from "react";

import moment from "moment";

//Permisos
import {
  EDITA_SOLICITUD,
  MODIFICA_ESTADO_SOLICITUD,
  MODIFICA_SOLICITUD,
  VER_VALID_DATOS,
} from "../../utils/permisos";

const RenderRow = ({
  usuario,
  index,
  style,
  solicitudes,
  filter,
  cambiarEstado,
  editar,
  verDetalles,
  disabledElements,
}) => {
  const [currentLista, setCurrentLista] = useState(
    solicitudes ? solicitudes : []
  );
  const [disabledElementsReq, setDisabledElementsReq] =
    useState(disabledElements);

  useEffect(() => {
    setDisabledElementsReq(disabledElements);
  }, [disabledElements]);

  if (currentLista && currentLista.length > 0) {
    if (filter === "") {
      return (
        <div style={style}>
          <div className="container-r-list-item">
            <div className="container-r-list-item-header">
              <div className="r-list-item-header-clave">
                {currentLista[index].soliAjusCodFor +
                  " - " +
                  currentLista[index].soliAjusNroFor}
              </div>
              <div className="r-list-item-details-title small-text" style={{ fontSize: "20px" }}>
                <div><strong>Fecha de alta:{" "}</strong>

                  {moment(currentLista[index].fecAlt).format("DD-MM-YYYY")}
                </div>
                <div>
                  <strong>Proveedor:</strong> {currentLista[index].user[0].fullName}
                </div>
              </div>
              <div className="r-list-item-details-clave">
                {currentLista[index].state}
              </div>
            </div>
            <div className="container-r-list-item-btn">
              {usuario.userType.some(
                (item) =>
                  MODIFICA_ESTADO_SOLICITUD.includes(item.typeName) &&
                  currentLista[index].state == "PENDIENTE"
              ) && (
                  <div
                    className={`r-list-item-btn-A ${disabledElementsReq ? "navbar-container-disabled" : ""
                      }`}
                    onClick={() =>
                      !disabledElements
                        ? cambiarEstado(currentLista[index])
                        : null
                    }
                  >
                    Modificar Estado
                  </div>
                )}
              {currentLista[index].state == "PENDIENTE" &&
                usuario.userType.some((item) =>
                  VER_VALID_DATOS.includes(item.typeName)
                ) && (
                  <div
                    className={`${"r-list-item-btn-A"} ${disabledElementsReq ? "navbar-container-disabled" : ""
                      }`}
                    onClick={() =>
                      !disabledElements ? editar(currentLista[index]) : null
                    }
                  >
                    Editar
                  </div>
                )}
              <div
                className={`${"r-list-item-btn-A"} ${disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                onClick={() =>
                  !disabledElements ? verDetalles(currentLista[index]) : null
                }
              >
                Detalles
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      const req_filters = currentLista.filter(
        (s) =>
          s.soliAjusCodFor
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(filter.toLowerCase().replace(/\s+/g, "")) ||
          (
            s.soliAjusCodFor.toLowerCase() +
            "-" +
            s.soliAjusNroFor.toString().toLowerCase().replace(/\s+/g, "")
          ).includes(filter.toLowerCase().replace(/\s+/g, "")) ||
          s.soliAjusNroFor
            .toString()
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(filter.toLowerCase().replace(/\s+/g, ""))
      );
      return (
        <div style={style}>
          <div className="container-r-list-item">
            <div className="container-r-list-item-header">
              <div className="r-list-item-header-clave">
                {req_filters[index].soliAjusCodFor +
                  " - " +
                  req_filters[index].soliAjusNroFor}
              </div>
              <div className="r-list-item-details-title small-text" style={{ fontSize: "20px" }}>
                <div><strong>Fecha de alta:{" "}</strong>

                  {moment(req_filters[index].fecAlt).format("DD-MM-YYYY")}
                </div>
                <div>
                  <strong>Proveedor:</strong> {req_filters[index].user[0].fullName}
                </div>
              </div>
              <div className="r-list-item-details-clave">
                {req_filters[index].state}
              </div>
            </div>
            <div className="container-r-list-item-btn">
              {usuario.userType.some(
                (item) =>
                  MODIFICA_ESTADO_SOLICITUD.includes(item.typeName) &&
                  req_filters[index].state == "PENDIENTE"
              ) && (
                  <div
                    className={`r-list-item-btn-A ${disabledElementsReq ? "navbar-container-disabled" : ""
                      }`}
                    onClick={() =>
                      !disabledElements
                        ? cambiarEstado(req_filters[index])
                        : null
                    }
                  >
                    Modificar Estado
                  </div>
                )}
              {req_filters[index].state == "PENDIENTE" &&
                usuario.userType.some((item) =>
                  VER_VALID_DATOS.includes(item.typeName)
                ) && (
                  <div
                    className={`${"r-list-item-btn-A"} ${disabledElementsReq ? "navbar-container-disabled" : ""
                      }`}
                    onClick={() =>
                      !disabledElements ? editar(req_filters[index]) : null
                    }
                  >
                    Editar
                  </div>
                )}
              <div
                className={`${"r-list-item-btn-A"} ${disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                onClick={() =>
                  !disabledElements ? verDetalles(currentLista[index]) : null
                }
              >
                Detalles
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
};

export default RenderRow;